import { render, staticRenderFns } from "./ConfirmUserRegister.vue?vue&type=template&id=c3084478&scoped=true&"
import script from "./ConfirmUserRegister.vue?vue&type=script&lang=js&"
export * from "./ConfirmUserRegister.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUserRegister.vue?vue&type=style&index=0&id=c3084478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3084478",
  null
  
)

export default component.exports